import { render, staticRenderFns } from "./AddMultiGroupModal.vue?vue&type=template&id=094645e8&scoped=true"
import script from "./AddMultiGroupModal.vue?vue&type=script&lang=js"
export * from "./AddMultiGroupModal.vue?vue&type=script&lang=js"
import style0 from "./AddMultiGroupModal.vue?vue&type=style&index=0&id=094645e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094645e8",
  null
  
)

export default component.exports